
export function fmtDictionary (value,dictionaryList) {
    var v = null;
    var d = dictionaryList;
    if (d != undefined && d != null && d.length > 0) {
        for (var i = 0; i < d.length; i++) {
            var tmp = d[i];
            if (tmp.code == value) {
                v = tmp.value
            }
        }
    }
    if (v == null) {
        if (value != undefined && value != null && value != '') {
            v = value
        } else {
            v = '--'
        }
    }
    return v
}
export function fmtDictionarySpare (value,dictionaryList,spareName) {
    var v = null;
    var d = dictionaryList;
    if (d != undefined && d != null && d.length > 0) {
        for (var i = 0; i < d.length; i++) {
            var tmp = d[i];
            if (tmp.code == value) {
                v = tmp[spareName]
            }
        }
    }
    if (v == null) {
        if (value != undefined && value != null && value != '') {
            v = value
        } else {
            v = '--'
        }
    }
    return v
}
export function fmtDateTime(date, fmt) {
    let ret;
    const opt = {
        "y+": date.getFullYear().toString(),        // 年
        "M+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "m+": date.getMinutes().toString(),         // 分
        "s+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

Number.prototype.toFixed = function (fractionDigits) {
    var number = String(this);
  var digits = fractionDigits || 0, length;

  if(digits < 0 && digits > 100)
    throw 'RangeError: toFixed() digits argument must be between 0 and 100';

  var decimal = number.match(/(?:\.)(\d*)/g);
  if (decimal && decimal.length) {
    // safari
    decimal=decimal.map(item=>item.replace('.',''))
  }
  var factor = Math.pow(10, digits);
  if (decimal && decimal[0].length >= digits)
    return String(Math.round(Number(number + '1') * factor) / factor);
  else {
    var length = digits - (decimal ? decimal[0].length : 0);
    var delimiter = number.includes('.') || !length ? '' : '.';
    return String(number) + delimiter + '0'.repeat(length);
  }
};
